import belongsToRenderedSpec from "@ext/markdown/elements/openApi/edit/logic/belongsToRenderedSpec";
import type { MouseEvent } from "react";

/**
 * The block moves by its own frame and is read everywhere else: a press on the rendered specification starts
 * a text selection, not a drag. The browser settles which of the two a press is from `draggable` at mousedown,
 * so it is set per press, along the line the node's `stopEvent` already draws.
 */
const dragFromChromeOnly = (event: MouseEvent<HTMLElement>) => {
	event.currentTarget.draggable = !belongsToRenderedSpec(event.target);
};

export default dragFromChromeOnly;
